import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import * as MUTATION_TYPES from "./mutation-types";

export const VUEX_GLS_ADMIN = {
  NAMESPACE: "glsAdmin",
  MUTATION_TYPES,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
